/**
 * CST Debug System - Simplified Version
 * 
 * Enable debugging with URL parameter: ?cst-debug=category1,category2
 * Or use ?cst-debug=all to enable all debug output
 * 
 * Usage: 
 * - CST_DEBUG.log('category', 'message', ...args)
 * - CST_DEBUG.isEnabled('category')
 * - window.debugHeightIssue() - Special function for quantity cart debugging
 */

(function() {
  'use strict';

  // Parse URL parameters to check for debug activation
  const urlParams = new URLSearchParams(window.location.search);
  const debugParam = urlParams.get('cst-debug');
  
  let enabledCategories = {};
  
  if (debugParam) {
    // Enable debugging
    window.CST_DEBUG_ENABLED = true;
    
    if (debugParam === 'all') {
      // Enable all categories
      enabledCategories.all = true;
    } else {
      // Enable specific categories
      debugParam.split(',').forEach(category => {
        enabledCategories[category.trim()] = true;
      });
    }
    
    console.log('[CST Debug] Enabled categories:', Object.keys(enabledCategories).join(', '));
  }

  // Create the simplified CST_DEBUG object
  window.CST_DEBUG = {
    // Check if a category is enabled
    isEnabled: function(category) {
      return window.CST_DEBUG_ENABLED && (enabledCategories.all || enabledCategories[category]);
    },
    
    // Log a message for a specific category
    log: function(category, message, ...args) {
      if (this.isEnabled(category)) {
        console.log(`[CST:${category}]`, message, ...args);
      }
    },
    
    // Log a warning for a specific category
    warn: function(category, message, ...args) {
      if (this.isEnabled(category)) {
        console.warn(`[CST:${category}]`, message, ...args);
      }
    },
    
    // Log an error for a specific category
    error: function(category, message, ...args) {
      if (this.isEnabled(category)) {
        console.error(`[CST:${category}]`, message, ...args);
      }
    },
    
    // Legacy compatibility: always return false (no verbose mode in simplified system)
    isVerbose: function() {
      return false;
    }
  };

  // Special debugging function for quantity cart height issues
  window.debugHeightIssue = function() {
    // Enable quantity cart debugging
    enabledCategories.quantityCart = true;
    window.CST_DEBUG_ENABLED = true;
    
    console.log('[CST:quantityCart] Analyzing height issues...');
    
    // Get all quantity cart containers
    const containers = document.querySelectorAll('[id^="QuantityCartAbsolute-"]');
    if (!containers.length) {
      console.log('[CST:quantityCart] No quantity cart containers found on this page');
      return;
    }
    
    containers.forEach(container => {
      const quantityBox = container.querySelector('.quantity-box');
      const buttonBox = container.querySelector('.button-box');
      
      // Add visual indicators
      container.style.border = '2px dashed red';
      if (quantityBox) quantityBox.style.border = '2px dashed blue';
      if (buttonBox) buttonBox.style.border = '2px dashed green';
      
      // Log container information
      console.log('[CST:quantityCart] Container:', {
        id: container.id,
        classList: container.className,
        computedHeight: getComputedStyle(container).height,
        quantityBoxHeight: quantityBox ? getComputedStyle(quantityBox).height : 'N/A',
        buttonBoxHeight: buttonBox ? getComputedStyle(buttonBox).height : 'N/A'
      });
    });
    
    console.log('[CST:quantityCart] Visual indicators added: Red=Container, Blue=QuantityBox, Green=ButtonBox');
    console.log('[CST:quantityCart] To remove indicators, refresh the page');
  };

})();